export default {
  // 超管
  '1_1_sys_super_admin': {
    weight: 99,
    open: [
      'index',
      'doc',
      'ability',
      'optcenter',
      'user',
      [
        'manage',
      ],
    ],
    'open-admin': [
      'admin/manage',
      [
        'admin/manage/system',
      ],
    ],
  },
  // 机构负责人
  '1_1_agency_manager': {
    weight: 21,
    open: [
      'index',
      'doc',
      'ability',
      'optcenter',
      'user',
      [
        'manage',
      ],
    ],
    'open-admin': [
      [
        'admin/manage/system',
      ],
    ],
  },
  // 机构分系统负责人
  '1_2_agency_sys_manager': {
    weight: 20,
    open: [
      'index',
      'doc',
      'ability',
      'optcenter',
      [
        'manage',
      ],
    ],
    'open-admin': [
      [
        'admin/manage/system',
      ],
    ],
  },
  // 供应商负责人
  '2_1_vendor_manager': {
    weight: 11,
    open: [
      'index',
      'doc',
      'ability',
      'user',
      'optcenter',
      [
        'manage',
      ],
    ],
    'open-admin': [
      [
        'admin/manage/system',
      ],
    ],
  },
  // 供应商分系统负责人
  '2_2_vendor_sys_manager': {
    weight: 10,
    open: [
      'index',
      'doc',
      'ability',
      'optcenter',
      [
        'manage',
      ],
    ],
    'open-admin': [
      [
        'admin/manage/system',
      ],
    ],
  },
};
